<template>
  <div>
    <div class="card second-card" v-loading="quizLoading">
      <h2 class="quiz bold">{{`[${quiz.quiz_grp_title} - ${quiz.tag}] ${quiz.quiz_content} (${quiz.point}점)`}}</h2>
      <el-card class="inner-card quiz-content" v-if="quiz.content_seq">
        <div slot="header" class="clearfix left bold">
          <span>지문</span>
        </div>
        <div class="text item">
          <div v-html="content"></div>
        </div>
      </el-card>
      <el-card class="inner-card" v-if="quiz.example">
        <div slot="header" class="clearfix left bold">
          <span>보기</span>
        </div>
        <div class="text item">
          <div v-html="example"></div>
        </div>
      </el-card>
      <div class="quiz-item">
        <div v-for="(item, index) in itemData" :key="item.item_seq" class="text item left">
          <span :class="item.item_no === quiz.solution ? 'font-red bold' : ''">{{itemNo[index] + ' ' + item.content}}</span>
        </div>
      </div>
      <el-card class="inner-card" v-if="quiz.description">
        <div slot="header" class="clearfix left bold">
          <span>정답 해설</span>
        </div>
        <div class="text item">
          <div v-html="description"></div>
        </div>
      </el-card>
      <div class="card-body text-right mb-3">
        <button type="button" class="btn btn-danger" @click="deleteQuiz">삭제</button>
        <button type="button" class="btn mint" @click="modifyQuiz">수정</button>
        <button type="button" class="btn btn-secondary" @click="downloadFile(file.download_url_c)" v-if="file.download_url_c"><i class="fas fa-download"></i> 지문</button>
        <button type="button" class="btn btn-default" @click="downloadFile(file.download_url_q)" v-if="file.download_url_q"><i class="fas fa-download"></i> 문제</button>
        <button type="button" class="btn btn-default" @click="downloadFile(file.download_url_a)" v-if="file.download_url_a"><i class="fas fa-download"></i> 정답</button>
        <!-- <el-button type="primary" @click="goListQuiz">목록으로</el-button>
        <el-button type="danger"  @click="deleteQuiz">삭제</el-button>
        <el-button type="primary" @click="modifyQuiz">수정</el-button>
        <el-button v-if="file.download_url_c" icon="el-icon-download" :title="file.file_name_c" @click="downloadFile(file.download_url_c)">지문</el-button>
        <el-button v-if="file.download_url_q" icon="el-icon-download" :title="file.file_name_q" @click="downloadFile(file.download_url_q)">문제</el-button>
        <el-button v-if="file.download_url_a" icon="el-icon-download" :title="file.file_name_a" @click="downloadFile(file.download_url_a)">정답</el-button> -->
      </div>
    </div>

    <div class="card second-card">
      <div class="card-body">
        <div class="d-flex">
          <div class="p-2">
            <h2>출제된 시험 <span class="number mint">{{tableData.length}}</span></h2>
          </div>
          <div class="ml-auto p-2">
          </div>
        </div>
      </div>
      <!-- 그리드 -->
      <stone-data-table
        :loading="searchLoading"
        :columns="examTableColumns"
        :data="tableData"
        :table-props="tableProps"
        :pagination-props="paginationProps"
        :action-col="examActionCol">
      </stone-data-table>
    </div>

    <el-dialog title="문제 수정" :visible.sync="dialogTableVisible" append-to-body class="dialog-medium">

      <el-form :model="quizModify" :rules="rules" status-icon ref="frm" label-width="120px" class="demo-form">
        <el-form-item label="문제유형" prop="quiz_type">
          <el-select v-model="quizModify.quiz_type" placeholder="문제유형을 선택하세요.">
            <el-option v-for="type in quizTypeData" :label="type.code_name" :value="type.code_id" :key="type.code_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="카테고리" prop="cate_code">
          <el-cascader
            :options="options"
            v-model="selectedOptions"
            change-on-select
            separator=">"
            style="width: 100%;">
          </el-cascader>
        </el-form-item>
        <el-form-item label="점수" prop="point">
          <el-input-number v-model="quizModify.point" :min="1" :max="5" :step="1" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="정답" prop="solution">
          <el-radio-group v-model="quizModify.solution" @change="changeSolutionHandler">
            <el-radio v-for="item in solutionLength" :key="item" :label="item + ''" border>{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="해설" prop="description">
          <el-input type="textarea" v-model.trim="quizModify.description" :rows="8"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div>
        ① ② ③ ④ ⑤
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">닫기</el-button>
        <el-button type="primary" @click="updateQuiz('frm')">수정</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M030102',
  mixins: [common.mixins],
  data () {
    return {
      isUse: true,
      isModify: true,
      dialogTableVisible: false,
      quizLoading: false,
      quiz: {
        quiz_seq: 0,
        quiz_grp_seq: '',
        quiz_grp_title: '',
        quiz_type: '',
        tag: '',
        cate_code: '',
        cate_code_name: '',
        cate_code_path: '',
        content_seq: 0,
        content: '',
        quiz_content: '',
        example: '',
        item_type: '',
        point: 0,
        solution: '',
        description: '',
        rmrk: '',
        ordby: '',
        use_yn: 'Y'
      },
      quizModify: {
        quiz_seq: 0,
        quiz_type: '',
        cate_code: '',
        cate_code_path: '',
        solution: '',
        point: 0,
        description: ''
      },
      rules: {
        quiz_type: [
          { required: true, message: '문제유형을 선택하십시오.', trigger: 'change' }
        ],
        cate_code: [
          { required: true, message: '카테고리명를 선택하십시오.', trigger: 'change' }
        ],
        solution: [
          { required: true, message: '정답을 선택하십시오.', trigger: 'change' }
        ],
        point: [
          { required: true, message: '점수를 입력하십시오.' },
          { type: 'number', message: '숫자만 입력가능합니다.' }
        ],
        description: [
          { required: true, message: '해설을 입력하십시오.' }
        ]
      },
      quizTypeData: [],
      options: [],
      selectedOptions: [],
      itemData: [],
      tableData: [],
      itemNo: ['①', '②', '③', '④', '⑤'],
      file: {
        file_seq_q: 0,
        file_name_q: '',
        download_url_q: '',
        file_seq_a: 0,
        file_name_a: '',
        download_url_a: '',
        file_seq_c: 0,
        file_name_c: '',
        download_url_c: ''
      },
      tableColumns: [
        {label: '시험번호', prop: 'exam_seq', align: 'left'},
        {label: '시험명', prop: 'exam_title', align: 'left'},
        {label: '과목', prop: 'title', align: 'left'},
        {label: '카테고리', prop: 'reg_user_name', align: 'left'},
        {label: '시험기간', prop: 'reg_dt', align: 'center', formatter: this.columnFormatterDate},
        {label: '응시인원', prop: 'exam_user_cnt', align: 'right'}
      ],
      paginationProps: {},
      tableProps: {height: 285},
      examActionCol: {
        label: ' ',
        props: {
          align: 'center',
          width: 200
        },
        buttons: [{
          handler: row => {
            this.$router.push({name: 'M050103', params: {exam_seq: row.exam_seq}})
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '상세'
        },
        {
          handler: row => {
            this.reScoringExamResult(row)
          },
          props: {
            type: 'danger',
            size: 'mini'
          },
          label: '재산정'
        }]
      }
    }
  },
  beforeCreate () {
    if (!this.$route.params.quiz_seq) {
      this.$router.push({name: 'M030101'})
    }
  },
  created () {
    Promise.all([
      common.axios.get('/category/tree'), // 카테고리
      common.axios.get('/code/QUIZ_TYPE/child') // 문제유형
    ]).then(response => {
      this.options = response[0].data
      this.quizTypeData = response[1].data
      // 조회
      this.$nextTick(() => {
        const quizSeq = this.$route.params.quiz_seq
        this.loadInfo(quizSeq)
        this.loadQuizExam(quizSeq)
      })
    })
  },
  computed: {
    content: function () {
      return this.replaceCarriageReturnToBr(this.quiz.content)
    },
    example: function () {
      return this.replaceCarriageReturnToBr(this.quiz.example)
    },
    description: function () {
      return this.replaceCarriageReturnToBr(this.quiz.description)
    },
    solutionLength: function () {
      return this.itemData.length
    }
  },
  methods: {
    // 문제 정보 조회
    loadInfo (quizSeq) {
      this.quizLoading = true
      common.axios.get('/quiz/' + quizSeq)
        .then(response => {
          const result = response.data
          // 퀴즈 정보
          Object.keys(this.quiz).forEach(key => {
            this.quiz[key] = result.quiz[key]
          })
          // 항목 정보
          this.itemData = result.quiz_item
          // 파일 정보
          if (result.quiz_file) {
            Object.keys(this.file).forEach(key => {
              this.file[key] = result.quiz_file[key]
            })
          }
          // 시험 정보
          // this.tableData = result.quiz_exam
          this.isUse = result.quiz.use_yn === 'Y'
          this.quizLoading = false
        })
        .catch(() => {
          this.quizLoading = false
        })
    },
    // 문제 정보 조회
    loadQuizExam (quizSeq) {
      this.loadStoneDataTable('/quiz/exam/' + quizSeq, {})
        .then(response => {
          this.tableData = response.data
        })
    },
    deleteQuiz () {
      this.$confirm('해당 문제를 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/quiz/' + this.quiz.quiz_seq)
          .then(response => {
            const result = response.data
            if (result.status < 0) {
              this.$message.error(result.message)
            } else {
              this.$message('삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M030101'})
              })
            }
          }).catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    },
    modifyQuiz () {
      Object.keys(this.quizModify).forEach(key => {
        this.quizModify[key] = this.quiz[key]
      })
      if (this.quiz.cate_code_path) {
        this.selectedOptions = this.quiz.cate_code_path.split(' > ')
      }
      this.$nextTick(() => {
        this.dialogTableVisible = true
      })
    },
    updateQuiz (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$confirm('해당 문제를 수정하시겠습니까?', '', {
          }).then(() => {
            const selectLength = this.selectedOptions.length
            this.quizModify.cate_code = this.selectedOptions[selectLength - 1]
            this.quizModify.cate_code_path = this.selectedOptions.join(' > ')
            common.axios.put('/quiz', this.quizModify).then(response => {
              const result = response.data
              if (result.status === 1) {
                Object.keys(this.quizModify).forEach(key => {
                  this.quiz[key] = this.quizModify[key]
                })
                this.$message('수정되었습니다.')
                this.$nextTick(() => {
                  this.dialogTableVisible = false
                })
              } else {
                this.$message.warning(result.message)
              }
            }).catch(() => {
              this.$message.error('수정에  실패하였습니다. 관리자에게 문의하세요')
            })
          }).catch(() => {
          })
        }
      })
    },
    handlerExamRowClickHandler (row) {
      this.$router.push({name: 'M050103', params: {exam_seq: row.exam_seq}})
    },
    goListQuiz () {
      // console.log('this.$route.params : ', this.$route.params)
      const pageName = this.$route.params.page
      if (pageName === 'M030103') {
        this.$router.push({name: pageName, params: {quiz: this.$route.params.quiz}})
      } else if (pageName === 'M040102') {
        this.$router.back()
        // this.$router.push({name: pageName, params: {exam_paper_seq: this.$route.params.exam_paper_seq}})
      } else {
        this.$router.push({name: 'M030103'})
      }
    },
    changeSolutionHandler (value) {
      const strLength = this.quizModify.description.length
      const strSolution = '[정답] ' + this.itemNo[value - 1]
      if (strLength === 0) {
        this.quizModify.description = strSolution
      } else if (strLength > 5 && this.quizModify.description.indexOf('[정답]') === 0) {
        const replaceStr = this.quizModify.description.substring(0, 6)
        const description = this.quizModify.description.replace(replaceStr, strSolution)
        this.quizModify.description = description
      }
    },
    reScoringExamResult (row) {
      // this.$message.info('준비중입니다.')
      this.$confirm('해당 시험을 재산정 하시겠습니까?', '', {
      }).then(() => {
        const param = {
          exam_seq: row.exam_seq,
          quiz_seq: this.quiz.quiz_seq
        }
        common.axios.put('/exam/quiz/result', param).then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (result.status === 1) {
            this.$message('시험 재산정이 완료되었습니다.')
            this.$nextTick(() => {
              this.loadQuizExam(this.quiz.quiz_seq)
            })
          } else {
            this.$message.warning(result.message)
          }
        }).catch(() => {
          this.$message.error('재산정에 실패하였습니다. 관리자에게 문의하세요')
        })
      }).catch(() => {
      })
    }
  },
  watch: {
    isUse: function (value) {
      this.quiz.use_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .quiz {
    text-align: left;
    padding-top: 20px;
    padding-left: 20px;
  }
  .quiz-content {
    background-color: #f5f9fc;
  }
  .left {
    text-align: left;
  }
  .bold {
    font-weight: bold;
  }
  .quiz-item {
    padding: 10px 25px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M030102.vue